import React from "react";
import { capitalize, Paper, Typography } from "@mui/material";
import { useT } from "../../i18n";
import FreeDaysTable from "../../components/freeDays/FreeDaysTable";
import Layout from "../../components/Layout";

export default function FreeDaysPage() {
  const { t: translation } = useT("freedays");

  return (
    <Layout title={capitalize(translation("free-days"))} showTitleInNav={false}>
      <Paper
        elevation={1}
        sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
      >
        <Typography variant="h5">
          {capitalize(translation("free-days"))}
        </Typography>

        <FreeDaysTable />
      </Paper>
    </Layout>
  );
}
